import { BoxProps, HStack } from '@chakra-ui/react';

import { Box } from 'shared';

type TBoardColumnHeader = BoxProps;

export const BoardColumnHeader = ({
  children,
  minHeight = 'auto',
  p = '4px 0px 0px 0px',
}: TBoardColumnHeader) => (
  <Box
    width="100%"
    minHeight={minHeight}
    borderBottom="var(--border-secondary)"
  >
    <HStack w="full" p={p} justifyContent="space-between">
      {children}
    </HStack>
  </Box>
);
